function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M423.965,264.175c0.001-0.062,0.035-0.113,0.035-0.175V48c0-4.418-3.582-8-8-8h-32c-4.418,0-8,3.582-8,8v16h-16v16h16v120 h-8v-24c0-14.866-10.238-27.286-24-30.864V136V96c0-11.13-7.65-20.428-17.943-23.13L307.238,16.41 C303.965,6.594,294.813,0,284.469,0h-13.84c-6.41,0-12.441,2.496-16.973,7.031l-5.512,5.512c-1.703,1.703-4.051,2.512-6.445,2.305 c-2.395-0.238-4.531-1.523-6.293-4.16C230.945,3.996,223.48,0,215.438,0h-13.039c-9.477,0-18.086,5.594-21.93,14.25l-25.977,58.449 C143.916,75.203,136,84.669,136,96v40v8.065c-17.343,0.351-31.359,14.51-31.359,31.935v24H88c-4.418,0-8,3.582-8,8v16 c0,15.285,10.77,28.102,25.121,31.254c0.082,0.258,0.214,0.492,0.304,0.746H80c-22.055,0-40,17.945-40,40v176c0,4.418,3.582,8,8,8 h384c4.418,0,8-3.582,8-8V296C440,282.968,433.642,271.483,423.965,264.175z M424,336h-36.001l-21.601-28.801 C364.891,305.184,362.52,304,360,304h-8v-32h32h16c13.234,0,24,10.766,24,24V336z M152,272v72c0,3.234,1.949,6.152,4.938,7.391 c2.992,1.23,6.426,0.551,8.719-1.734L176,339.313V408v24h-32V272H152z M152,144h16v32h-8c-4.41,0-8-3.59-8-8V144z M240,176 c4.418,0,8-3.582,8-8v-24h16v48h-48v-48h16v16h-8v16H240z M208,208h24v8c0,4.41-3.59,8-8,8h-24v16h24c6.169,0,11.744-2.404,16-6.242 c4.256,3.838,9.831,6.242,16,6.242h24v-16h-24c-4.41,0-8-3.59-8-8v-8h24c4.418,0,8-3.582,8-8v-56h16v88 c0,9.922-2.605,19.582-7.582,28.02c-6.831,11.919-17.837,20.611-30.547,24.916l-1.549,0.53C251.09,287.068,245.617,288,240,288 c-2.497,0-4.971-0.167-7.409-0.495c-3.047-0.409-6.007-1.15-8.914-2.042l-1.546-0.53c-12.714-4.31-23.733-13.02-30.6-24.997 C186.605,251.582,184,241.922,184,232v-88h16v56C200,204.418,203.582,208,208,208z M328,144v24c0,4.41-3.59,8-8,8h-8v-32H328z M240,304c2.453,0,4.873-0.209,7.284-0.456L240,318.113l-7.284-14.569C235.127,303.791,237.547,304,240,304z M180.188,272 c0.474,0.712,1.045,1.339,1.543,2.032c0.821,1.142,1.658,2.259,2.541,3.346c1.053,1.297,2.157,2.534,3.293,3.749 c0.945,1.009,1.89,2.006,2.888,2.956c1.21,1.152,2.475,2.227,3.76,3.29c1.048,0.867,2.085,1.737,3.179,2.542 c1.362,1.002,2.78,1.907,4.208,2.811c1.123,0.71,2.225,1.441,3.385,2.089c1.52,0.848,3.096,1.576,4.674,2.313 c0.878,0.41,1.709,0.914,2.604,1.289l20.582,41.164c1.355,2.711,4.125,4.422,7.156,4.422s5.801-1.711,7.156-4.422l20.58-41.159 c0.941-0.394,1.815-0.921,2.738-1.354c1.514-0.71,3.029-1.406,4.488-2.219c1.233-0.687,2.405-1.462,3.596-2.219 c1.344-0.855,2.684-1.706,3.969-2.648c1.175-0.861,2.287-1.793,3.409-2.726c1.199-0.997,2.383-1.999,3.517-3.074 c1.069-1.014,2.08-2.08,3.087-3.161c1.068-1.146,2.108-2.309,3.103-3.528c0.924-1.133,1.798-2.3,2.654-3.495 c0.489-0.681,1.051-1.296,1.517-1.997H304h8v52.688l-18.344-18.344c-3.125-3.125-8.188-3.125-11.313,0L240,348.688l-42.344-42.344 c-3.125-3.125-8.188-3.125-11.313,0L168,324.688V272h0.641H180.188z M376,256h-8.785c0.09-0.254,0.222-0.488,0.304-0.746 c3.025-0.665,5.841-1.842,8.48-3.298V256z M336,312v24v96h-32v-24v-68.688l10.344,10.344c2.289,2.285,5.719,2.965,8.719,1.734 c2.988-1.238,4.938-4.156,4.938-7.391v-72h8V312z M192,323.313l42.344,42.344c1.563,1.563,3.609,2.344,5.656,2.344 s4.094-0.781,5.656-2.344L288,323.313V400h-96V323.313z M144,448h40c4.418,0,8-3.582,8-8v-24h96v24c0,4.418,3.582,8,8,8h40v16H144 V448z M352,320h4l12,16h-16V320z M408,56v200h-8h-8V56H408z M352,176v32c0,4.418,3.582,8,8,8h16v12.234 c-1.87,6.761-8.01,11.766-15.359,11.766c-4.418,0-8,3.582-8,8c0,4.41-3.59,8-8,8h-36.919c2.724-7.645,4.278-15.732,4.278-24v-40h8 c13.234,0,24-10.766,24-24v-5.775C348.759,165,352,170.103,352,176z M195.09,20.746c1.281-2.883,4.148-4.746,7.309-4.746h13.039 c2.68,0,5.168,1.332,7.082,4.199c4.004,6.004,10.418,9.859,17.602,10.57c7.16,0.707,14.23-1.809,19.336-6.914l5.512-5.512 c1.512-1.512,3.523-2.344,5.66-2.344h13.84c3.449,0,6.5,2.199,7.59,5.473L308.9,72H172.309L195.09,20.746z M152,96 c0-4.41,3.59-8,8-8h160c4.41,0,8,3.59,8,8v32h-24H176h-24V96z M120,248c0-4.418-3.582-8-8-8c-8.824,0-16-7.176-16-16v-8h16.641 c4.418,0,8-3.582,8-8v-32c0-8.605,6.838-15.591,15.359-15.935V168c0,13.234,10.766,24,24,24h8v40c0,8.276,1.555,16.37,4.271,24 h-3.631H128C123.59,256,120,252.41,120,248z M56,296c0-13.234,10.766-24,24-24h48v192H56V296z M352,464v-16h24v-16h-24v-16h24v-16 h-24v-16h24v-16h-24v-16h72v112H352z"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 152,
  y: 400,
  width: 16,
  height: 16
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 312,
  y: 400,
  width: 16,
  height: 16
});

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  version: 1.1,
  id: "Capa_1",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 480 480",
  style: {
    "enableBackground": "new 0 0 480 480"
  },
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#A38563"
  },
  d: "M136,264H80c-17.68,0-32,14.32-32,32v176h88v-32V264z"
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    "fill": "#806749"
  },
  points: "296,440 296,408 184,408 184,440 136,440 136,472 344,472 344,440 "
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#A38563"
  },
  d: "M400,264h-56v176v32h88V296C432,278.32,417.68,264,400,264z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 384,
  y: 48,
  style: {
    "fill": "#E6E6E6"
  },
  width: 32,
  height: 216
}), /*#__PURE__*/React.createElement("rect", {
  x: 360,
  y: 64,
  style: {
    "fill": "#999999"
  },
  width: 24,
  height: 16
}), /*#__PURE__*/React.createElement("rect", {
  x: 400,
  y: 48,
  style: {
    "fill": "#CCCCCC"
  },
  width: 16,
  height: 216
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#A38563"
  },
  d: "M295.36,264c-10.96,19.12-31.68,32-55.36,32s-44.4-12.88-55.36-32H184v56v88h112v-88v-56H295.36z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  style: {
    "fill": "#CA7300"
  },
  points: "184,440 184,408 184,320 184,264 136,264 136,440 \t"
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    "fill": "#CA7300"
  },
  points: "296,408 296,440 344,440 344,264 296,264 296,320 \t"
})), /*#__PURE__*/React.createElement("polygon", {
  style: {
    "fill": "#806749"
  },
  points: "160,264 160,344 192,312 240,360 288,312 320,344 320,264 "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    "fill": "#D7CABB"
  },
  points: "216,288 240,336 264,288 "
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 152,
  y: 400,
  style: {
    "fill": "#FFD422"
  },
  width: 16,
  height: 16
}), /*#__PURE__*/React.createElement("rect", {
  x: 312,
  y: 400,
  style: {
    "fill": "#FFD422"
  },
  width: 16,
  height: 16
})), /*#__PURE__*/React.createElement("polygon", {
  style: {
    "fill": "#FE946F"
  },
  points: "344,344 344,312 360,312 384,344 "
}), /*#__PURE__*/React.createElement("rect", {
  x: 344,
  y: 344,
  style: {
    "fill": "#FFB398"
  },
  width: 88,
  height: 128
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 344,
  y: 432,
  style: {
    "fill": "#FE946F"
  },
  width: 32,
  height: 16
}), /*#__PURE__*/React.createElement("rect", {
  x: 344,
  y: 400,
  style: {
    "fill": "#FE946F"
  },
  width: 32,
  height: 16
}), /*#__PURE__*/React.createElement("rect", {
  x: 344,
  y: 368,
  style: {
    "fill": "#FE946F"
  },
  width: 32,
  height: 16
})), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#D4C8B8"
  },
  d: "M136.64,152L136.64,152c-13.255,0-24,10.745-24,24v32H88v16c0,13.255,10.745,24,24,24h0v0 c0,8.837,7.163,16,16,16h40.64H304h40.64c8.837,0,16-7.163,16-16v0h0c13.255,0,24-10.745,24-24v-16H360v-32 c0-13.255-10.745-24-24-24h0H136.64z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#EBE5DD"
  },
  d: "M304,136v96c0,11.68-3.12,22.64-8.64,32c-10.96,19.12-31.68,32-55.36,32s-44.4-12.88-55.36-32 c-5.52-9.36-8.64-20.32-8.64-32v-96H304z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#D4C8B8"
  },
  d: "M224,240h-24v-16h24c4.41,0,8-3.59,8-8v-16h16v16C248,229.234,237.234,240,224,240z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#D4C8B8"
  },
  d: "M280,240h-24c-13.234,0-24-10.766-24-24v-16h16v16c0,4.41,3.59,8,8,8h24V240z"
})), /*#__PURE__*/React.createElement("rect", {
  x: 208,
  y: 136,
  style: {
    "fill": "#FFB398"
  },
  width: 64,
  height: 64
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#EE8700"
  },
  d: "M240,176h-16v-16h8v-24h16v32C248,172.418,244.418,176,240,176z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#806749"
  },
  d: "M336,136H144V96c0-8.837,7.163-16,16-16h160c8.837,0,16,7.163,16,16V136z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#EE8700"
  },
  d: "M160,80l27.777-62.498C190.345,11.724,196.075,8,202.398,8h13.039c5.35,0,10.345,2.674,13.313,7.125 l0.424,0.636c5.601,8.401,17.487,9.578,24.627,2.439l5.513-5.513C262.314,9.686,266.384,8,270.627,8h13.84 c6.887,0,13.001,4.407,15.179,10.94L320,80H160z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#68533B"
  },
  d: "M320,80h-24h-8c8.836,0,16,7.163,16,16v40h32V96C336,87.163,328.836,80,320,80z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#CA7300"
  },
  d: "M275.647,18.94L296,80h24l-20.353-61.06C297.469,12.407,291.355,8,284.468,8h-13.84 c-1.727,0-3.403,0.347-5.012,0.88C270.255,10.462,274.035,14.106,275.647,18.94z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FE946F"
  },
  d: "M144,136h32v48h-16c-8.837,0-16-7.163-16-16V136z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FE946F"
  },
  d: "M336,136h-32v48h16c8.837,0,16-7.163,16-16V136z"
})), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);

export default __webpack_public_path__ + "static/media/chasseur.6e7120e1.svg";
export { SvgComponent as ReactComponent };